import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getEmployeeIncentives = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/api/incentive/employee/current`, {
      headers: getAuthHeader(),
    });
    
    return response.data.data || {};
  } catch (error) {
    console.error('Error fetching employee incentives:', error);
    return {
      performance_Incentive: 0,
      sales_Incentive: 0,
      total_Incentive: 0,
      performance_Message: 'Unable to load incentives',
      sales_Message: 'Unable to load incentives'
    };
  }
};
